import { call, put, select, takeLatest } from 'redux-saga/effects';

import TillerBack from '../../models/TillerBack';

import * as Actions from './actions';

import tillerApi from '../../api/tiller';

export function* createTillerBackOffice(action) {
  let account = yield select(state => state.account);
  let opportunity = yield select(state => state.opportunity);
  let shippingAddress = yield select(state => state.shippingAddress);
  if (account && opportunity && shippingAddress) {
    try {
      let SFaccountId = account.getId();
      if (SFaccountId.length === 18) {
        SFaccountId = SFaccountId.substring(0, SFaccountId.length - 3);
      }
      let back = new TillerBack(
        '8a7152e0-e62d-11e7-9cf8-0a7a7aeae940',
        opportunity.getContactEmail(),
        account.getPhone(),
        opportunity.getContactFirstName(),
        opportunity.getContactName(),
        opportunity.getName(),
        opportunity.getFullName(),
        'EUR',
        'FR',
        shippingAddress.getZipcode(),
        shippingAddress.getCity(),
        shippingAddress.getStreet(),
        SFaccountId,
      );
      let tillerBack = yield call(tillerApi.createBack, back);
      yield put({ type: Actions.BACK_OFFICE_CREATED, tillerBack });
    } catch (e) {
      yield put(Actions.ERROR_CREATE_BACK_OFFICE);
    }
  }
}

export function* sendBackOfficeIdToSalesforce(action) {
  let tillerBackId = action.tillerBack.data;
  let account = yield select(state => state.account);
  let accountId = account.getId();
  let toSend = {
    accountId: accountId,
    backOfficeId: tillerBackId.id,
  };
  try {
    yield put({ type: Actions.BACK_OFFICE_ID_SENT_TO_SALESFORCE, toSend });
  } catch (e) {
    yield put(Actions.ERROR_CREATE_BACK_OFFICE);
  }
}

export function* backOfficeListener() {
  yield takeLatest(Actions.CREATE_TILLER_BACK_OFFICE, createTillerBackOffice);
  yield takeLatest(Actions.BACK_OFFICE_CREATED, sendBackOfficeIdToSalesforce);
}



// WEBPACK FOOTER //
// ./src/services/TillerBackService/saga.js